import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import RatingCard from '../components/fleet/RatingCard';

const NextPage = ({ onBack }) => {
  return (
    <div className="min-h-screen ">
      {/* Header Section */}
      <div className=" border-b px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button 
              onClick={onBack}
              className="flex items-center space-x-2 text-blue-600 hover:text-blue-800"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span>Back</span>
            </button>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              <h1 className="text-lg font-bold text-blue-900">GJ 18 AB 2828</h1>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span className="text-lg font-bold text-blue-900">ICU on Wheels</span>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-lg font-bold text-blue-900">10:04 PM | 4.8 km | 15min</span>
          </div>
          
          <div className="flex items-center space-x-10">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-sm font-medium text-green-600">Active</span>
              <span className="text-sm text-gray-500">Round journey</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-sm font-medium text-red-600">Critical</span>
            </div>
          </div>
        </div>
        
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <h2 className="text-lg font-bold text-blue-900">Ramesh Suresh</h2>
            </div>
            <div className="flex space-x-3">
              <button className="text-blue-600 text-sm hover:underline">Call Now</button>
              <button className="text-blue-600 text-sm hover:underline">History</button>
              <button className="text-blue-600 text-sm hover:underline">View Profile</button>
            </div>
          </div>
          
          <div className="flex items-center space-x-40">
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm text-gray-600 ">Avg. Response Time</span>
              <span className="text-sm font-bold text-gray-900">10:30 Mins</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
              </svg>
              <span className="text-sm text-gray-600">Ratings</span>
              <span className="text-sm font-bold text-gray-900">4.7/5</span>
            </div>
            <button className="text-blue-600 text-sm hover:underline">View More</button>
          </div>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="p-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column - Equipment, Live Camera, Live Location */}
        <div className="lg:col-span-2 space-y-1">
          {/* Equipments Section */}
          <div className=" rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-4">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <h3 className="text-lg font-semibold">Equipments</h3>
            </div>
            
            <div 
              className="flex gap-2 overflow-x-auto"
              style={{
                width: '840px',
                height: '131px',
                paddingTop: '8px',
                paddingBottom: '8px',
                gap: '10px',
                opacity: 1
              }}
            >
              <div 
                className="bg-green-50 border border-green-200 flex-shrink-0 flex flex-col justify-center"
                style={{
                  width: '160px',
                  height: '80px',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  paddingTop: '8px',
                  paddingRight: '24px',
                  paddingBottom: '8px',
                  paddingLeft: '24px',
                  gap: '4px',
                  opacity: 1
                }}
              >
                <p className="text-sm font-bold text-green-800">Full</p>
                <p className="text-xs text-green-800">Fuel</p>
              </div>
              <div 
                className="bg-red-50 border border-red-200 flex-shrink-0 flex flex-col justify-center"
                style={{
                  width: '160px',
                  height: '80px',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  paddingTop: '8px',
                  paddingRight: '24px',
                  paddingBottom: '8px',
                  paddingLeft: '24px',
                  gap: '4px',
                  opacity: 1
                }}
              >
                <p className="text-sm font-bold text-red-800">500 kg</p>
                <p className="text-xs text-red-800">Oxygen</p>
              </div>
              <div 
                className="bg-yellow-50 border border-yellow-200 flex-shrink-0 flex flex-col justify-center"
                style={{
                  width: '160px',
                  height: '80px',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  paddingTop: '8px',
                  paddingRight: '24px',
                  paddingBottom: '8px',
                  paddingLeft: '24px',
                  gap: '4px',
                  opacity: 1
                }}
              >
                <p className="text-sm font-bold text-yellow-800">200 L</p>
                <p className="text-xs text-yellow-800">Alcohol</p>
              </div>
              <div 
                className="bg-green-50 border border-green-200 flex-shrink-0 flex flex-col justify-center"
                style={{
                  width: '160px',
                  height: '80px',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  paddingTop: '8px',
                  paddingRight: '24px',
                  paddingBottom: '8px',
                  paddingLeft: '24px',
                  gap: '4px',
                  opacity: 1
                }}
              >
                <p className="text-sm font-bold text-green-800">500 kg</p>
                <p className="text-xs text-green-800">Nitrogen</p>
              </div>
              <div 
                className="bg-yellow-50 border border-yellow-200 flex-shrink-0 flex flex-col justify-center"
                style={{
                  width: '160px',
                  height: '80px',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  paddingTop: '8px',
                  paddingRight: '24px',
                  paddingBottom: '8px',
                  paddingLeft: '24px',
                  gap: '4px',
                  opacity: 1
                }}
              >
                <p className="text-sm font-bold text-yellow-800">24° C</p>
                <p className="text-xs text-yellow-800">Temperature</p>
              </div>
            </div>
          </div>

          {/* Live Location Section */}
          <div className=" rounded-lg  p-4">
            <div className="flex items-center space-x-2 mb-4">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <h3 className="text-lg font-semibold">Live Location</h3>
            </div>
            
            <div 
              className="bg-gray-100 rounded-lg relative border-2 border-green-500 overflow-hidden"
              style={{
                width: '840px',
                height: '210px',
                borderRadius: '8px',
                border: '2px solid #10B981'
              }}
            >
              {/* Google Maps Integration */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2157!2d-74.0059!3d40.7128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQyJzQ2LjAiTiA3NMKwMDAnMjEuMiJX!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg"
              ></iframe>
              
              {/* Current Location Overlay */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                <div className="w-6 h-6 bg-blue-500 rounded-full border-3 border-white shadow-lg flex items-center justify-center">
                  <div className="w-3 h-3 bg-white rounded-full"></div>
                </div>
                <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                  Current Location
                </div>
              </div>
              
              {/* Fullscreen Button */}
              <button className="absolute bottom-2 right-2 p-2 bg-white rounded shadow-lg hover:bg-gray-50 transition-colors z-10">
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                </svg>
              </button>
              
              {/* Map Controls */}
              <div className="absolute top-2 right-2 flex flex-col space-y-1 z-10">
                <button className="p-2 bg-white rounded shadow hover:bg-gray-50 transition-colors">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </button>
                <button className="p-2 bg-white rounded shadow hover:bg-gray-50 transition-colors">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="px-6 pt-0">
        <div className="grid grid-cols-2 gap-4">
          {/* System Safety Score */}
          <div 
            className="bg-white rounded-lg border border-gray-200"
            style={{
              width: '408px',
              height: '140px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
              padding: '16px',
              gap: '16px',
              opacity: 1
            }}
          >
            <div className="flex items-center space-x-3 h-full">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">System Safety Score</h3>
                <p className="text-2xl font-bold text-gray-900">80%</p>
                <p className="text-sm text-gray-600">Some areas need improvement</p>
              </div>
            </div>
          </div>

          {/* Threat Exposure Level */}
          <div 
            className="bg-white rounded-lg border border-gray-200"
            style={{
              width: '408px',
              height: '140px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
              padding: '16px',
              gap: '16px',
              opacity: 1
            }}
          >
            <div className="flex items-center space-x-3 h-full">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">Threat Exposure Level</h3>
                <p className="text-2xl font-bold text-gray-900">60%</p>
                <p className="text-sm text-gray-600">Your system is moderately exposed to potential threats.</p>
              </div>
            </div>
          </div>

          {/* System Safety Score - Bottom Left */}
          <div 
            className="bg-white rounded-lg border border-gray-200"
            style={{
              width: '408px',
              height: '140px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
              padding: '16px',
              gap: '16px',
              opacity: 1
            }}
          >
            <div className="flex items-center space-x-3 h-full">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">System Safety Score</h3>
                <p className="text-2xl font-bold text-gray-900">80%</p>
                <p className="text-sm text-gray-600">Some areas need improvement</p>
              </div>
            </div>
          </div>

          {/* Threat Exposure Level - Bottom Right */}
          <div 
            className="bg-white rounded-lg border border-gray-200"
            style={{
              width: '408px',
              height: '140px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
              padding: '16px',
              gap: '16px',
              opacity: 1
            }}
          >
            <div className="flex items-center space-x-3 h-full">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">Threat Exposure Level</h3>
                <p className="text-2xl font-bold text-gray-900">60%</p>
                <p className="text-sm text-gray-600">Your system is moderately exposed to potential threats.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>

        {/* Right Column - Ratings and Vehicle Performance */}
        <div className="space-y-4">
          <RatingCard 
            title="Ratings"
            subtitle="Graph 1"
            value="12.07"
            rating={12.07}
            maxRating={100}
            color="orange"
          />

          <RatingCard 
            title="Vehicle Performance"
            subtitle="Graph 2"
            value="12.07"
            rating={12.07}
            maxRating={100}
            color="orange"
          />
        </div>
      </div>



    </div>
  );
};

export default NextPage;
